import { NavLink } from 'react-router-dom';
import { 
  TreePine, 
  ClipboardList, 
  Users, 
  FileText, 
  Settings,
  UserPlus,
  Archive
} from 'lucide-react';

interface NavigationProps {
  isAdmin: boolean;
  onClose: () => void;
}

export function Navigation({ isAdmin, onClose }: NavigationProps) {
  return (
    <nav className="flex-1 px-2 py-4 overflow-y-auto">
      <NavLink
        to="/dashboard/tree"
        onClick={onClose}
        className={({ isActive }) =>
          `flex items-center px-4 py-2 text-sm font-medium rounded-md ${
            isActive
              ? 'bg-primary text-white'
              : 'text-gray-600 hover:bg-background-light hover:text-primary'
          }`
        }
      >
        <TreePine className="h-5 w-5 ml-3" />
        شجرة العائلة     </NavLink>

      <NavLink
        to="/dashboard/requests"
        onClick={onClose}
        className={({ isActive }) =>
          `flex items-center px-4 py-2 text-sm font-medium rounded-md mt-2 ${
            isActive
              ? 'bg-primary text-white'
              : 'text-gray-600 hover:bg-background-light hover:text-primary'
          }`
        }
      >
        <ClipboardList className="h-5 w-5 ml-3" />
        {isAdmin ? 'الطلبات' : 'طلباتي'}
      </NavLink>

      {isAdmin && (
        <>
          <NavLink
            to="/dashboard/register-requests"
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center px-4 py-2 text-sm font-medium rounded-md mt-2 ${
                isActive
                  ? 'bg-primary text-white'
                  : 'text-gray-600 hover:bg-background-light hover:text-primary'
              }`
            }
          >
            <UserPlus className="h-5 w-5 ml-3" />
            طلبات التسجيل
          </NavLink>

          <NavLink
            to="/dashboard/users"
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center px-4 py-2 text-sm font-medium rounded-md mt-2 ${
                isActive
                  ? 'bg-primary text-white'
                  : 'text-gray-600 hover:bg-background-light hover:text-primary'
              }`
            }
          >
            <Users className="h-5 w-5 ml-3" />
            المستخدمين
          </NavLink>
        </>
      )}

      <NavLink
        to="/dashboard/profiles"
        onClick={onClose}
        className={({ isActive }) =>
          `flex items-center px-4 py-2 text-sm font-medium rounded-md mt-2 ${
            isActive
              ? 'bg-primary text-white'
              : 'text-gray-600 hover:bg-background-light hover:text-primary'
          }`
        }
      >
        <Archive className="h-5 w-5 ml-3" />
        الأرشيف
      </NavLink>

      {isAdmin && (
        <NavLink
          to="/dashboard/settings"
          onClick={onClose}
          className={({ isActive }) =>
            `flex items-center px-4 py-2 text-sm font-medium rounded-md mt-2 ${
              isActive
                ? 'bg-primary text-white'
                : 'text-gray-600 hover:bg-background-light hover:text-primary'
            }`
          }
        >
          <Settings className="h-5 w-5 ml-3" />
          الإعدادات
        </NavLink>
      )}
    </nav>
  );
}